const DominicanFlagIcon = ({ width = 20, height = 12.5, className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://w3.org" 
      viewBox="0 0 32 20" 
      width={width} 
      height={height} 
      className={className}
      style={{ 
        borderRadius: '3px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
        display: 'inline-block',
        verticalAlign: 'middle',
        ...props.style
      }}
      {...props}
    >
      {/* Background White Cross */}
      <rect width="32" height="20" fill="#ffffff" />
      
      {/* Top Left / Bottom Right (Ultramarine Blue) */}
      <rect width="13.5" height="8.5" fill="#002D62" />
      <rect x="18.5" y="11.5" width="13.5" height="8.5" fill="#002D62" />
      
      {/* Top Right / Bottom Left (Vermillion Red) */}
      <rect x="18.5" width="13.5" height="8.5" fill="#CE1126" />
      <rect y="11.5" width="13.5" height="8.5" fill="#CE1126" />
    
    </svg>
  );
};

export default DominicanFlagIcon;
